/**
 * Escapes a value for safe interpolation into an HTML string (text content or a
 * double-quoted attribute). Use it whenever admin- or user-provided data is
 * concatenated into markup that ends up in v-html.
 */
export function escapeHtml(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
